/**
 * Created by Jerker Nord on 2019-10-23.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Linear, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";

export class BonusBunniesB5NearWinView extends BaseView {

    private _layer:ScalableLayer;
    private _nearWinTL:TimelineLite;
    private _nearWinFrame:TimelineSprite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._nearWinFrame = new TimelineSprite(GameResources.getTextures("B5Anticipation"));
        this._nearWinFrame.anchor.set(0.5, 0.5);
        this._nearWinFrame.alpha = 0;
        this._nearWinFrame.blendMode = PIXI.BLEND_MODES.SCREEN;
        this.addChild(this._nearWinFrame);
    }

    public playNearWinTL(reel:number, row:number, activeReels:number):void {
        if(this._nearWinTL && this._nearWinTL.isActive()) {
            this._nearWinTL.pause();
            this._nearWinTL.kill();
        }
        let startDelay:number = 0;
        if(activeReels > 1) {
            if(GameSetting.isFastSpin == true) {
                startDelay = activeReels * 0.36;
            } else {
                startDelay = activeReels * 0.4;
            }
        }
        this._nearWinTL = new TimelineLite();
        this._nearWinTL.add(() => this._nearWinFrame.position.x = Helper.getSymbolPositions(reel, row)[0], "+=" + startDelay);
        this._nearWinTL.add(() => EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName : "BONUS_REELSET_LAST_SYMBOL"})));
        this._nearWinTL.add(() => this._nearWinFrame.position.y = Helper.getSymbolPositions(reel, row)[1]);
        this._nearWinTL.add(this.getAttentionTL());
    }

    private getAttentionTL():TimelineMax {
        const attentionTL:TimelineMax = new TimelineMax();
        attentionTL.add([
            () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.ANTICIPATION),
            () => this._nearWinFrame.playLoop()
        ]);
        attentionTL.add(new TweenLite(this._nearWinFrame, 0.2, {alpha : 1, ease : Linear.easeNone}));
        return attentionTL;
    }

    public removeNearWinAnimation():void {
        if(this._nearWinTL && this._nearWinTL.isActive()) {
            this._nearWinTL.pause();
            this._nearWinTL.kill();
        }
        SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.ANTICIPATION);
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.stopLoopingRumbleChest();
        this._nearWinFrame.alpha = 0;
        this._nearWinFrame.stopLoop();
    }
}